export const navHeaderItems = [
  {
    href: '/fonctionnalites',
    name: 'Fonctionnalités'
  },
  {
    href: '/cas-usages',
    name: 'Cas d\'usages'
  },
  {
    href: '/box',
    name: 'Box'
  },
  {
    href: '/ecrans',
    name: 'Écrans'
  },
  {
    href: '/temoignages',
    name: 'Témoignages'
  },
  {
    href: '/tarifs',
    name: 'Tarifs'
  }
]

export const navFooterProductItems = [
  { href: '/fonctionnalites', name: 'Fonctionnalités' },
  { href: '/cas-usages', name: 'Cas d\'usages' },
  { href: '/box', name: 'Box' },
  { href: '/ecrans', name: 'Écrans professionnels' },
  { href: '/temoignages', name: 'Témoignages' },
  { href: '/tarifs', name: 'Tarifs' }
]

export const navFooterCompanyItems = [
  { href: '/contact', name: 'Contact' },
  { href: '/demo', name: 'Demander une démo' },
  { href: '/devis', name: 'Demander un devis' },
  { href: '/conditions-generales', name: 'Conditions générales' }
]

export const navSocialItems = [
  {
    href: 'https://www.linkedin.com/company/livedisplay-pro/',
    name: 'LinkedIn',
    icon: 'ph:linkedin-logo-duotone'
  },
  {
    href: 'https://www.instagram.com/livedisplay_pro/',
    name: 'Instagram',
    icon: 'ph:instagram-logo-duotone'
  },
  {
    href: 'https://www.facebook.com/livedisplay.pro',
    name: 'Facebook',
    icon: 'ph:facebook-logo-duotone'
  },
  {
    href: 'https://x.com/livedisplay_pro',
    name: 'X (Twitter)',
    icon: 'ph:x-logo-duotone'
  }
]
